import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Lightbulb, ArrowRight } from "lucide-react";

export default function SuggestionsCard({ api }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/admin/suggestions").then(({ data }) => setD(data)).catch(() => {});
  }, [api]);
  if (!d) return null;
  const latest = d.suggestions[0];
  return (
    <section className="brutal-border p-4 sm:p-5 mb-8 flex flex-col sm:flex-row sm:items-center justify-between gap-3" data-testid="admin-suggestions-card">
      <div className="min-w-0">
        <div className="font-mono-label text-[10px] text-muted-foreground inline-flex items-center gap-1.5">
          <Lightbulb size={12} className="text-[#FFD600]" /> APP SUGGESTIONS · <span data-testid="admin-suggestions-new" className={d.new ? "text-[#FFD600]" : ""}>{d.new} NEW</span> · {d.suggestions.length} TOTAL
        </div>
        {latest && <p className="text-sm mt-1 truncate text-muted-foreground">Latest from {latest.name || latest.email}: “{latest.message}”</p>}
      </div>
      <Link to="/community?tab=suggestions" data-testid="admin-suggestions-open" className="min-h-[40px] px-4 border border-[#262626] hover:border-white font-mono-label text-[11px] inline-flex items-center gap-2 shrink-0 transition-colors">
        Open suggestions <ArrowRight size={12} />
      </Link>
    </section>
  );
}
